// Generated by pnpm --filter @langfuse/icons generate. Do not edit.
import { createIcon } from "../../create-icon.js";
import { LucideNewspaper as RawLucideNewspaper } from "lucide-react";
export const LucideNewspaper = /* @__PURE__ */ createIcon(RawLucideNewspaper, "LucideNewspaper", 2);
